module.exports = __webpack_public_path__ + "img/aoneLogo.f28b7f08.svg";